module.exports = __webpack_public_path__ + "static/media/Cheri Liney-01.3f6d77b1.svg";